/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { calculations, CALCULATION_METHODS } from '../constants';
import { addUrlParams } from '../utils';
import { SegmentedControl } from './ui';

const CalculationTab = ({ onChange, activeValue }) => {
  const [period, setPeriod] = useState(activeValue);

  const handleButtonClick = value => {
    addUrlParams('calculationMethod', value);
    setPeriod(value);
    onChange(value);
  };

  useEffect(() => {
    setPeriod(activeValue);
  }, [activeValue]);

  return (
    <SegmentedControl
      items={Object.entries(calculations).map(([key, value]) => ({
        value,
        label: CALCULATION_METHODS[key]
      }))}
      value={period}
      onChange={handleButtonClick}
    />
  );
};

export default CalculationTab;
